function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 81.0697,
  y: 54.4006,
  width: 111.5142,
  height: 157.4873,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.2929,90.6667H121.96a2.6676,2.6676,0,0,0-2.6667,2.6666V120a2.6677,2.6677,0,0,0,2.6667,2.6667h13.3333a16,16,0,0,0,0-32ZM128,0A128,128,0,1,0,256,128,128.0057,128.0057,0,0,0,128,0Zm7.2929,154.6667H121.96a2.6676,2.6676,0,0,0-2.6667,2.6666V192a16,16,0,0,1-32,0V85.3333A26.6627,26.6627,0,0,1,113.96,58.6667h21.3333a48,48,0,0,1,0,96Z",
  fill: "#5cb11b"
});

var SvgWebappIconParkedLightTheme = function SvgWebappIconParkedLightTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconParkedLightTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-parked-light-theme.5d0fe236.svg";
export { ForwardRef as ReactComponent };